import {getMethod} from '~/api'

async function get(request) {
    return await getMethod('/proxy/popular-hotels', request)
}

export {get}
